<template lang="pug">
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio>
    <rect width="5" height="20" fill="currentColor"/>
    <rect x="15" width="5" height="20" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgPauseBars'
}
</script>

<style>
</style>
